import React, { useEffect, useState } from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import api from '../../../utils/api';
import { useParams } from 'react-router-dom';
import ViewForm from '../../../component/reusable/ViewForm';

const ViewManufacturers = () => {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const { id } = useParams()

  const fetchCategoryDetails = async () => {
    setLoading(true)
    try {
      const { data, status } = await api.viewManufacturer(id)

      if (status == 200) {
        setData(data?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    if (id) {
      fetchCategoryDetails()
    }
  }, [id])
  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Manufacturer" pagename="View Manufacturer" />
      {loading ? <div>Please wait...</div>
        :
        <ViewForm data={data} from={'Manufacturer Name*'} />
      }
    </div>
  );
};

export default ViewManufacturers;
